import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step1", "step2", "nameField", "nameValue"]

  next() {
    const name = this.nameFieldTarget.value.trim()
    if (!name) {
      this.nameFieldTarget.focus()
      return
    }
    this.nameValueTarget.value = name
    this.nameFieldTarget.disabled = true
    this.step1Target.hidden = true
    this.step2Target.hidden = false
    this.step2Target.querySelector("input, button, label")?.focus()
  }
}
